/**
 * ExperimentNames
 * An enum of all running A/B experiments fetched from PostHog.
 * TIP - right click each key in the enum and select "Find All References" to see where this is used
 *
 * Keys are TS-friendly identifiers. Values are the PostHog flag keys.
 * Every entry must have a corresponding multivariate feature flag in PostHog,
 * AND a matching variants enum + EXPERIMENT_VARIANTS registry entry below.
 *
 * Each entry should carry an `expires` comment. Past-expiry entries should be
 * either extended (with reason) or removed (winning variant inlined).
 */
export enum ExperimentNames {
    testExperiment01 = "test-experiment-01",
    // expires 2026-07-15
    // inlinePopupAuthExtended = "inline-popup-auth-extended",
    // globalPaywallExperiment01 = "global-paywall-experiment-01",
    // freeTrialsExperiment = "free-trials-experiment",
}

// // // //
// Per-experiment variant enums
// Variant string values must match the variants configured in PostHog exactly.

export enum TestExperiment01Variants {
    test = "test",
    control = "control",
}

/**
 * InlinePopupAuthExtendedVariants
 * Allowed variants for the `inline-popup-auth-extended` experiment.
 */
// export enum InlinePopupAuthExtendedVariants {
//     control = "control",
//     forcedAuthWorkEmailOnlyAfter3Pages = "forced-auth-work-email-only-after-3-pages",
//     forcedAuthWorkEmailOnlyImmediate = "forced-auth-work-email-only-immediate",
//     forcedAuthEmailOnlyAfter3Pages = "forced-auth-email-only-after-3-pages",
//     forcedAuthEmailOnlyImmediate = "forced-auth-email-only-immediate",
//     forcedAuthAfter3Pages = "forced-auth-after-3-pages",
// }

// export enum GlobalPaywallExperiment01Variants {
//     control = "control",
//     globalPaywallEnabled = "global-paywall-enabled",
// }

// export enum FreeTrialsExperimentVariants {
//     control = "control",
//     freeTrialsEnabled = "free-trials-enabled",
// }

// // // //

/**
 * EXPERIMENT_VARIANTS
 * Single source of truth mapping each experiment to its variant enum.
 * Used at the type level (to derive `ExperimentState`) and at runtime
 * (to validate variant strings returned from PostHog).
 */
export const EXPERIMENT_VARIANTS = {
    [ExperimentNames.testExperiment01]: TestExperiment01Variants,
    // [ExperimentNames.inlinePopupAuthExtended]: InlinePopupAuthExtendedVariants,
    // [ExperimentNames.globalPaywallExperiment01]: GlobalPaywallExperiment01Variants,
    // [ExperimentNames.freeTrialsExperiment]: FreeTrialsExperimentVariants,
} as const;
